import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import { convertDateWithValidation, validate } from "../../helper/losDataHelper";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";

const TakeOverDetails = ({ takeOverDetails }) => {

    const takeOverDetailsColumns = [
      {
        field: "detailsId",
        headerName: "Details ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "internalapplicationid",
        headerName: "Internal Application ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "otdCategoryCode",
        headerName: "OTD Category Code",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "otdCategory",
        headerName: "OTD Category",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "institutionName",
        headerName: "Institution Name",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "createdBy",
        headerName: "Created By",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "modifiedBy",
        headerName: "Modified By",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "createdDate",
        headerName: "Created Date",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
        valueGetter: (params) =>
          convertDateWithValidation(params.row.createdDate),
      },
      {
        field: "modifiedDate",
        headerName: "Modified Date",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
        valueGetter: (params) =>
          convertDateWithValidation(params.row.modifiedDate),
      },
    ];

    return(
        <AccordianContainer
        id="accord"
        title="TakeOver Details"
        initialOpen={false}
      >
        <Box sx={{ marginTop: "-0.5%" }}>
        <CustomDataGrid
          noDataMessage="No Data"
          rows={ validate(takeOverDetails) ?
            takeOverDetails.map((item, index) => ({
              id: index + 1,
              ...item,
            })) : []}
          columns={takeOverDetailsColumns}
          pageSize={15}
          pageSizeOptions={[10]}
          gridLazyLoad={() => {}}
          gridHeight={305}
          getRowId={(row) => row.detailsId}
          onCellKeyDown={(event, param) => {
            (param.key === "e" || param.key === "E") &&
              param.preventDefault();
          }}
        />
        </Box>
        </AccordianContainer>
    );
}

export default TakeOverDetails;